import React from 'react'

import AllHostcups from './HostcupDetails/AllHostcups'
import AdminNav from '../../Admin/AdminNav';
import AddHostcup from './AddHostcup';

function HostcupDashboard() {

    return (
        <div>
            <AdminNav />
            <div className="container">
                <a href="https://footgrail.netlify.app/login" target="_blank">Logg inn for å redigere</a>


                <h4>Legg til ny turnering</h4>
                <AddHostcup />

                <hr />
                <AllHostcups />

                <hr />
            </div>

        </div>
    )

}
export default HostcupDashboard